export default "__VITE_ASSET__DpuXHQ2E__"